import { V2Position } from '@/core/migrate';
import { NFTX_LP_STAKING } from '@/domain/migrate';
import {
  Provider,
  Signer,
  getChainConstant,
  getContract,
  increaseByPercentage,
} from 'nftx.js';
import NftxV2LpStaking from '@/domain/migrate/abis/NftxV2LpStaking';

const unstakeLiquidity = ({
  v3VaultId,
  position,
  provider,
  network,
  signer,
  slippage,
}: {
  v3VaultId: string;
  position: Pick<V2Position, 'vaultId' | 'migrateOptions' | 'slp'>;
  provider: Provider;
  network: number;
  signer: Signer;
  slippage: number;
}) => {
  const contract = getContract({
    address: getChainConstant(NFTX_LP_STAKING, network),
    abi: NftxV2LpStaking,
    provider,
    signer,
  });
  const migrateOption = position.migrateOptions.find(
    (o) => o.vaultId === v3VaultId
  );
  if (!migrateOption) {
    throw new Error('Invalid vaultId');
  }
  // We can only migrate whole units so we floor the vToken amount
  let slpToRemove = migrateOption.maxSlp;
  slpToRemove = increaseByPercentage(slpToRemove, slippage);
  if (slpToRemove > position.slp) {
    slpToRemove = position.slp;
  }

  return contract.write.withdraw({
    args: [BigInt(position.vaultId), slpToRemove],
  });
};

export default unstakeLiquidity;
